import { Api } from "./Api";
import axios from "axios";
import { Option } from "../models/Option";

export class HolidaysApi extends Api {
    constructor() {
        super("app/holidays");
    }

    getNext(): Promise<any> {
        return axios.get(this.apiUrl + "next").then(function (response) {
            return response.data;
        });
    }

    getList(): Promise<any> {
        return axios.get(this.apiUrl + "list").then(function (response) {
            return response.data;
        });
    }

    getListAsOptions(): Promise<Array<Option>> {
        return this.getList().then(function (list) {
            return _.map(list, function (value, key) {
                return <Option>{
                    id: key,
                    name: value,
                };
            });
        });
    }
}
